import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { blockSpecificV0Schema } from './v0';
import { blockSpecificLegacySchema } from '../legacy/schema';
import { migrateLegacySpecificToV0 } from '../legacy/migration';

export const SpecificBlockEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: blockSpecificV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: blockSpecificLegacySchema, up: migrateLegacySpecificToV0 }],
});

export type SpecificBlock = InferredEntity<typeof SpecificBlockEntitySchema>;
